import i18n from 'i18n';
import i18next from 'i18next';
import { Callback, TFunction } from 'i18next';

export type TTranslationsFunction = TFunction<'translation', undefined, 'translation'>;

interface ITranslationsProvider {
	language: string;
	changeLanguage: (lng?: string, callback?: Callback) => Promise<TTranslationsFunction>;
	staticTranslate: (key: string | string[], options?: any) => string;
}

const translationsProvider: ITranslationsProvider = {
	language: i18n.language,
	changeLanguage: i18n.changeLanguage,
	staticTranslate: i18next.t
};

export default translationsProvider;
